var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6684 8.45C19.6184 3.83 15.5884 1.75 12.0484 1.75C12.0484 1.75 12.0484 1.75 12.0384 1.75C8.50844 1.75 4.46844 3.82 3.41844 8.44C2.24844 13.6 5.40844 17.97 8.26844 20.72C9.32844 21.74 10.6884 22.25 12.0484 22.25C13.4084 22.25 14.7684 21.74 15.8184 20.72C18.6784 17.97 21.8384 13.61 20.6684 8.45ZM12.0484 13.46C10.3084 13.46 8.89844 12.05 8.89844 10.31C8.89844 8.57 10.3084 7.16 12.0484 7.16C13.7884 7.16 15.1984 8.57 15.1984 10.31C15.1984 12.05 13.7884 13.46 12.0484 13.46Z",
    fill: "#576EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsIcon);
export default __webpack_public_path__ + "static/media/gpsIcon.243eb9def04015c34fafab38065a811f.svg";
export { ForwardRef as ReactComponent };